import { words } from "lodash";
import { v4 as uuid } from "uuid";

import { CustomField as DooapCustomField } from "store/environments/tenants/custom-fields/dooap-types";
import {
    CustomFieldType,
    InvoiceType,
} from "store/environments/tenants/custom-fields/erp-types";
import { CustomerType } from "store/customers/add-new-customer/add-new-customer-types";
import { t } from "i18next";

export const getInvoiceKeyPrefix = (invoiceType: InvoiceType): string =>
    `${InvoiceType[invoiceType]}-`;

export const getTableKeyPrefix = (table: string): string => `${table}-`;

export const checkCustomFieldsInitialized: (
    fields: readonly DooapCustomField[]
) => boolean = (fields: readonly DooapCustomField[]) => {
    return (
        fields &&
        fields.length > 0 &&
        fields.every(
            (value) => value.uiColumnName && value.uiColumnName.length > 0
        )
    );
};

export const getErpType = (customerType: CustomerType | null) => {
    switch (customerType) {
        case CustomerType.AX2012:
            return t("tenantConfig.d365InformationPage.erpType.ax");
        case CustomerType.D365:
            return t("tenantConfig.d365InformationPage.erpType.d365");
        default:
            return t("tenantConfig.d365InformationPage.erpType.default");
    }
};

export const generateId = (): number => {
    const id = uuid();

    // Use first 8 hex characters (32 bits) and convert to number
    return parseInt(id.substring(0, 8), 16) >>> 0;
};

export const customData1 = "CustomData1";
export const customData2 = "CustomData2";
export const customData3 = "CustomData3";

export const customField1 = "CustomField1";
export const customField2 = "CustomField2";
export const customField3 = "CustomField3";

export const defaultValue: DooapCustomField[] = [
    {
        code: customField1,
        xmlPath: null,
        databaseColumnName: customData1,
        uiColumnName: null,
    },
    {
        code: customField2,
        xmlPath: null,
        databaseColumnName: customData2,
        uiColumnName: null,
    },
    {
        code: customField3,
        xmlPath: null,
        databaseColumnName: customData3,
        uiColumnName: null,
    },
];

export const customFieldTypes = [
    {
        label: words(customField1).join(" "),
        value: CustomFieldType.CustomField1,
    },
    {
        label: words(customField2).join(" "),
        value: CustomFieldType.CustomField2,
    },
    {
        label: words(customField3).join(" "),
        value: CustomFieldType.CustomField3,
    },
];
